export const itemsListing = [
  {
    id: 0,
    name: 'All Items',
    color: 'white',
    selected: true,
  },
  {
    id: 1,
    name: 'Wraps',
    color: '#D62246',
    selected: false,
  },
  {
    id: 2,
    name: 'Salads',
    color: '#F5E663',
    selected: false,
  },
  {
    id: 3,
    name: 'Vegan',
    color: '#16C172',
    selected: false,
  },
  {
    id: 4,
    name: 'Sandwiches',
    color: '#3992E3',
    selected: false,
  },
  {
    id: 5,
    name: 'Drinks',
    color: '#1E3888',
    selected: false,
  },
  {
    id: 6,
    name: 'Snacks',
    color: '#8F3985',
    selected: false,
  },
  {
    id: 7,
    name: 'Desserts',
    color: '#390030',
    selected: false,
  },
];
